<!-- Main container -->
@if (property) {
  <div class="layout-row full">
    <div class="full place-start-center">
      @switch (property.type) {
        @case (PropertyType.VALUE) {
          <mat-form-field class="layout-row" subscriptSizing="dynamic" elderDense>
            @if (showLabel) {
              <mat-label>{{ label }}</mat-label>
            }
            <input
              matInput
              [name]="name"
              type="text"
              [required]="required"
              [(ngModel)]="value"
              #valueModel="ngModel"
            />
            <mat-error elderValidationError></mat-error>
          </mat-form-field>
        }
        @case (PropertyType.NUMBER) {
          <mat-form-field class="layout-row" subscriptSizing="dynamic" elderDense>
            @if (showLabel) {
              <mat-label>{{ label }}</mat-label>
            }
            <input
              matInput
              [name]="name"
              type="number"
              [required]="required"
              [(ngModel)]="numberValue"
              #numberModel="ngModel"
            />
            <mat-error elderValidationError></mat-error>
          </mat-form-field>
        }
        @case (PropertyType.VALUE_LIST) {
          <elder-label-input
            class="layout-row"
            [label]="showLabel ? label : null"
            [name]="name"
            [required]="required"
            [(ngModel)]="values"
            #listModel="ngModel"
          >
            <mat-error elderValidationError></mat-error>
          </elder-label-input>
        }
        @case (PropertyType.QUANTITY_LIST) {
          <elder-label-input
            class="layout-row"
            [label]="showLabel ? label : null"
            [name]="name"
            [required]="required"
            [(ngModel)]="values"
            #listModel="ngModel"
          >
            <mat-error elderValidationError></mat-error>
          </elder-label-input>
        }
        @case (PropertyType.QUANTITY) {
          <mat-form-field elderDense class="layout-row">
            @if (showLabel) {
              <mat-label>{{ label }}</mat-label>
            }
            <elder-quantity-input
              class="flex"
              [required]="required"
              [(quantityValue)]="quantityValue"
              [unit]="quantityUnit"
            >
            </elder-quantity-input>
            <mat-error elderValidationError></mat-error>
          </mat-form-field>
        }
        @case (PropertyType.BOOLEAN) {
          <div>
            @if (tripleStateBoolean) {
              <div class="layout-row place-start-center">
                @if (showLabel) {
                  <mat-label>{{ label }}</mat-label>
                }
                <mat-checkbox
                  elderTripleStateCheckbox
                  [name]="name"
                  [required]="required"
                  [value]="readTripleStateBooleanValue()"
                  (valueChange)="applyTripleStateBooleanValue($event)"
                >
                </mat-checkbox>
              </div>
            } @else {
              <div class="layout-row place-start-center">
                @if (showLabel) {
                  <mat-label>{{ label }}</mat-label>
                }
                <mat-checkbox [name]="name" [required]="required" [(ngModel)]="booleanValue">
                </mat-checkbox>
              </div>
            }
          </div>
        }
        @case (PropertyType.VALUE_ENUMERATION) {
          <mat-form-field class="flex layout-row" subscriptSizing="dynamic" elderDense>
            @if (showLabel) {
              <mat-label>{{ label }}</mat-label>
            }
            <mat-select
              [multiple]="!isSingleSelection()"
              [name]="name"
              [required]="required"
              [ngModel]="isSingleSelection() ? value : values"
              (ngModelChange)="isSingleSelection() ? (value = $event) : (values = $event)"
            >
              @for (value of getAllowedValues(); track value) {
                <mat-option [value]="value">{{ value }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @case (PropertyType.QUANTITY_ENUMERATION) {
          <mat-form-field class="flex layout-row" subscriptSizing="dynamic" elderDense>
            @if (showLabel) {
              <mat-label>{{ label }}</mat-label>
            }
            <mat-select
              [multiple]="!isSingleSelection()"
              [name]="name"
              [required]="required"
              [ngModel]="isSingleSelection() ? value : values"
              (ngModelChange)="isSingleSelection() ? (value = $event) : (values = $event)"
            >
              @for (value of getAllowedValues(); track value) {
                <mat-option [value]="value">{{ value }} {{ property.unit }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }
    </div>
  </div>
}
